<template>
	<div>
		<Bj :bjData="bjData" />
		<div class="contactBox">
			<div class="mobileTitle">联系方式</div>
			<div class="company">湖南米啦科技有限公司</div>
			<div class="minbox">
				<div class="item ">
					<img src="../../assets/pc/contact/mail.png" alt="" />
					<span>guohao@hskgoo.com</span>
				</div>
				<div class="item">
					<img src="../../assets/pc/contact/address.png" alt="" />
					<span>湖南省长沙市岳麓区天顶街道环湖路 1177号方茂苑（二期）12、13、15栋1916室</span>
				</div>
			</div>
		</div>
		<myBaiduMap class="myBaiduMap" />
	</div>
</template>

<script>
import myBaiduMap from '@/components/mobile/baiduMap.vue'
import Bj from '@/components/mobile/bj'
export default {
	components: {
		Bj,
		myBaiduMap,
	},
	data() {
		return {
			bjData: {
				imgUrl: 'https://qn.juquedu.com/1111.png',
				title: '联系我们',
				minTitle: '欢迎联络和合作',
			},
		}
	},
}
</script>

<style lang="scss" scoped>
.contactBox {
	box-sizing: border-box;
	padding: 15px;
	.company {
		font-size: 24px;
		margin-top: 24px;
	}
	.minbox {
		font-size: 14px;
		margin-top: 33px;
		margin-bottom: 10px;
		.item {
			margin-top: 10px;
			display: flex;
			align-items: center;
		}
		img {
			width: 32px;
			height: 32px;
			margin-right: 10px;
		}
	}
}
.myBaiduMap {
	margin-bottom: 50px;
}
</style>
